import { colors } from '@styles/vars'
import styled from 'styled-components'

const EmphasizedContent = styled.div<{ narrow?: boolean, padding?: string, background?: string, border?: string, width?: string }>`
    padding: ${props => {
        if (props.padding) return props.padding
        if (props.narrow) return "15px"
        return "20px"
    }};
    
    width: ${props => props.width || "auto"};
    background: ${props => props.background || colors.white};
    border: ${props => props.border || `${colors.border} 1px solid`};
    border-radius: 10px;
`

export default EmphasizedContent